import { makeStyles } from '@material-ui/core';

const styles = theme => ({
  tableCell: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#202A38',
    '&:nth-of-type(1)': {
      position: 'relative',

      '& > div:first-child .new-design-cell': {
        display: 'block',
        position: 'absolute'
      },
      '& > div:nth-child(2) .new-design-cell': {
        display: 'block',
        paddingLeft: 32,
        paddingTop: 50,
      },
      '& .new-design-header': {
        display: 'block',
        paddingLeft: 32,
      }
    },
    '&:nth-of-type(2)': {
      '& .new-design-cell': {
        display: 'block',
        paddingTop: 50,
      }
    },
    '&:nth-of-type(3)': {
      '& .new-design-cell': {
        display: 'block',
        paddingTop: 50,
      }
    },
    '&:nth-of-type(4)': {
      '& .new-design-cell': {
        display: 'block',
        paddingTop: 50,
      }
    }
  },
});

export default makeStyles(styles)
